<div class="layout-row layout-lt-md-column gap-2percent">
  <mat-form-field [ngStyle]="{ flex: '0 0 ' + (flex || '83%') }">
    <input
      matInput
      [readonly]="true"
      [value]="fileName || ''"
      placeholder="{{ 'labels.inputs.No file selected' | translate }}"
    />
  </mat-form-field>

  <span class="flex-10 align-center">
    <button mat-button (click)="uploadFile.click()">
      <fa-icon icon="folder-open" size="lg"></fa-icon>
      &nbsp;&nbsp;
      {{ "labels.buttons.Browse" | translate }}
    </button>
  </span>
</div>

<input
  type="file"
  #uploadFile
  accept="{{ acceptFilter }}"
  (change)="onFileSelect($event)"
  [style.display]="'none'"
/>
